<div *ngIf="(availableWidgets$ | async)?.salary_table?.columns as availableWidgets" class="card shadow">
  <app-help name="employee.detail.salary"></app-help>
  
  <div class="card-header card-header--padding">
    <div class="row">
      <div class="col-6 col-sm-6 col-md-7">
        <p class="modal-title font-16 text-dark pt-2 pb-2">
          <span>{{ 'employees.salaries' | translate }}</span>
        </p>
      </div>
      
      <div class="col-6 col-sm-6 col-md-5 text-right align-self-center">
        <app-table-settings (refreshFn)="refetchSalaries.emit('refetch')" [entity]="'salary_table'"></app-table-settings>
        <button (click)="openSalaryCreateModal(null)"
            *ngIf="widgetTemplatesService.canSeeButton('Salary', 'Create', employee.permissions)"
            [createButton]="'employees_salaries.action_create' | translate"
            class="ml-2"
        ></button>
      </div>
    </div>
  </div>
  
  <div class="card-body">
    <ng-container *ngIf="entityRequests">
      <ng-container *ngFor="let request of entityRequests">
        <div *ngIf="request?.entity_type === 'App\\Models\\EmployeeSalary'" class="alert alert-warning mb-3 w-100 shadow">
          <span>{{ 'employees_salaries.waiting_to_be_processed' | translate }} </span>
          <span><u (click)="openEntityUpdateRequestModal(request)">{{ 'employees_salaries.waiting_to_be_processed_part_2' | translate }}</u></span>
          <span>{{ 'employees_salaries.waiting_to_be_processed_'+(request?.action) | translate }} </span>
          <span class="font-weight-bold">{{ request?.entity_label }}</span>.
        </div>
      </ng-container>
    </ng-container>
    <div class="table-responsive">
      <table class="table table-centered mb-0">
        <tbody>
          <ng-container *ngIf="salaries$ | async; let salaries; else loadingTemplate">
            <ng-container *ngIf="salaries?.length; else noSalariesTemplate">
              <tr *ngFor="let s of salaries">
                <td *ngIf="availableWidgets.amount">
                  <span [ngClass]="{'hidden-sensitive-value': hiddenInputs}">{{ s.amount_formatted }} </span>
                </td>
                
                <td *ngIf="availableWidgets.frequency">{{ 'employees_salaries.frequency_adj_' + s.frequency | translate }}</td>
                
                <td *ngIf="availableWidgets.from_to">
                  <span>{{ s.from | date:'dd.MM.yyyy' }} </span>
                  <span *ngIf="s.to">- {{ s.to | date:'dd.MM.yyyy' }}</span>
                </td>
                
                <td *ngFor="let column of s?.list_custom_fields" appDataTableDataCell>
                  <ng-container *ngIf="column.type !== 'TEXTAREA' && column.type !== 'RICHTEXT'">
                    <ng-container [ngSwitch]="column.type">
                      <span *ngSwitchCase="'PERCENT'"> {{ column.value }} %</span>
                      <span *ngSwitchCase="'AMOUNT'"> {{ column.value | localizedCurrency }}</span>
                      <span *ngSwitchCase="'DATE'"> {{ column.value | date: 'dd.MM.yyyy' }}</span>
                      <span *ngSwitchCase="'DATETIME'"> {{ column.value | date: 'dd.MM.yyyy HH:mm' }}</span>
                      <span *ngSwitchCase="'TOGGLE'">  {{ (column.value ? 'global.YES' : 'global.NO') | translate }}</span>
                      <span *ngSwitchDefault>{{ column.value }}</span>
                    </ng-container>
                  </ng-container>
                </td>
                
                <td class="text-right">
                  <a
                      (click)="openSalaryCreateModal(s)"
                      *ngIf="widgetTemplatesService.canSeeButton('Salary', 'Edit', employee.permissions)"
                      class="btn btn-link btn-icon p-0"
                      title="{{ 'global.action_edit' | translate }}"
                  >
                    <i class="mdi mdi-eye-outline text-muted mdi-24px"></i>
                  </a>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          
          <ng-template #loadingTemplate>
            <app-row-loader></app-row-loader>
          </ng-template>
          
          <ng-template #noSalariesTemplate>
            <tr class="text-center">
              <td colspan="3">{{ 'global.empty_widget_error' | translate }}</td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
  </div>
</div>
